module.exports = __webpack_public_path__ + "69b3af6879d2aeba7a92744f75207120.svg";